/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllRole = param => {
    return axiosInstance.post(`/api/gcadmin/v1/role/getAll`,param).then(res => res.data)
}
const getRoleHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/role/get-history`,param).then(res => res.data)
}
const createRole = (role) => {
    return axiosInstance.post(`/api/gcadmin/v1/role/create`,role).then(res => res.data)
}
const editRole = (role) => {
    return axiosInstance.post(`/api/gcadmin/v1/role/update`,role).then(res => res.data)
}
export {
    getAllRole,
    createRole,
    editRole,
    getRoleHistory
}
